export default {
	validations: {
		required: "Wert ist erforderlich.",
		undefined: "Wert ist erforderlich.",
		email: "Wert ist keine gültige E-Mail-Adresse",
		minLength: "Dieses Feld sollte mindestens ${min} Zeichen lang sein",
		maxLength: "Die maximal erlaubte Länge ist ${max}",
		minValue: "Der zulässige Mindestwert ist ${min}",
		maxValue: "Der maximal erlaubte Wert ist ${max}",
		numeric: "Wert muss numerisch sein",
		ipAddress: "Der Wert ist keine gültige IP-Adresse",
		sameAs: "Der Wert muss gleich dem Wert von ${otherName} sein",
	}
}